import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./Reducer/AuthReducer";
import SelectedInvoiceReducer from "./Reducer/SelectedInvoiceReducer";
import SelectedInvoiceDataReducer from "./Reducer/SelectedInvoiceDataReducer";
import SelectedClientReducer from "./Reducer/SelectedClientReducer";
import DashboardFlagReducer from "./Reducer/AddInvoiceReducer";
import sortingSlice from "./Reducer/SortingSliceReducer";
import ApplicationTypeReducer from "./Reducer/ApplicationTypeReducer";
export const store = configureStore({
  reducer: {
    auth: AuthReducer,
    selectedInvoice: SelectedInvoiceReducer,
    selectedClient: SelectedClientReducer,
    selectedInvoiceData: SelectedInvoiceDataReducer,
    dashboardFlag: DashboardFlagReducer,
    sorting: sortingSlice,
    applicationType: ApplicationTypeReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 
export default store;
